export function getLetterSpacingFromRem(rem: string) {
  if (typeof window !== 'undefined') {
    const pxVal = parseFloat(rem) * parseFloat(window.getComputedStyle(document.documentElement).fontSize);
    return `-${pxVal / 32}px`;
  }
}
